var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('app-table',{attrs:{"id":"employee-company-assets-table","options":_vm.options},on:{"action":_vm.triggerActions}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }